import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import './ViewOrderModal.css';

const ViewOrderModal = ({ show, handleClose, order, handleEdit }) => {
    return (
        <Modal show={show} onHide={handleClose} aria-labelledby="view-order-title">
            <Modal.Header closeButton>
                <Modal.Title id="view-order-title">View Order Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {order ? (
                    <div>
                        <p><strong>Invoice Id:</strong> {order.invoice_id}</p>
                        <p><strong>Invoice Number:</strong> {order.invoice_number}</p>
                        <p><strong>Reference :</strong> {order.reference}</p>
                        <p><strong>Description:</strong> {order.order_description}</p>
                        <p><strong>Status:</strong> {order.order_status}</p>
                        <p><strong>Added On: </strong>{new Date(order.added_date).toLocaleString()}</p>
                        {order.last_updated_at ? <p><strong>Last Updated On: </strong>{new Date(order.last_updated_at).toLocaleString()}</p> : null}
                        {order.ordered_by ? <p><strong>Ordered By: </strong>{order.ordered_by}</p> : null}
                        {order.assembled_by ? <p><strong>Assembled By: </strong>{order.assembled_by}</p> : null}
                        {order.completed_by ? <p><strong>Completed By: </strong>{order.completed_by}</p> : null}
                        <p><strong>Products:</strong></p>
                        <div className="product-list">
                            {/* <ul>
                                {order.products && order.products.length > 0 ? (
                                    order.products.map((product, index) => (
                                  
                                        <div key={index} className="product-item">
                                            <p><strong>{product.name}</strong> - Quantity: {product.quantity}</p>
                                            <Form.Check
                                                type="checkbox"
                                                id={`is-assembled-${index}`}
                                                label="Is Assembled"
                                                checked={product.is_assembled}
                                                readOnly
                                            />
                                        </div>
                                    ))
                                ) : (
                                    <p>No products are associated with this order.</p>
                                )}
                            </ul> */}
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Product Name</th>
                                        <th>Quantity</th>
                                        <th>Is Assembled </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.products && order.products.length > 0 ? (
                                        order.products.map((product, index) => (
                                            <tr key={index}>
                                                <td>{product.name}</td>
                                                <td>{product.quantity}</td>
                                                <td>
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`is-assembled-${index}`}
                                                        checked={product.is_assembled}
                                                        readOnly
                                                    />
                                                    {product.is_assembled ? (
                                                        <span className="badge bg-success">Assembled</span>
                                                    ) : (
                                                        <span className="badge bg-danger">Not Assembled</span>
                                                    )}
                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3">No products are associated with this order.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                        </div>
                    </div>
                ) : (
                    <p>No order details available</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                {order && (
                    <Button variant="primary" onClick={() => handleEdit(order)}>
                        Edit Order
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ViewOrderModal;
